import { ArrowRight } from "lucide-react";
import { GeneralContentSchemaType } from "~/lib/schemas/generalContentSchema.schema";

interface HighlightLinksComponentProps {
  contents: GeneralContentSchemaType[];
}
export function HighlightLinksComponent({ contents }: HighlightLinksComponentProps) {

  const _handleClick = (actionUrls: string[]) => {
    if (actionUrls.length > 0) {
      const firstUrl = actionUrls[0];
      if (firstUrl && (firstUrl.startsWith('http://') || firstUrl.startsWith('https://'))) {
        window.open(firstUrl, '_blank');
      } else {
        console.error("[HighlightLinksComponent] Err: Invalid action URL");
      }
    } else {
      console.error("[HighlightLinksComponent] Err: No action URL available");
    }
  };

  return (
    <div className="flex flex-col space-y-1 rounded-full">
      {contents.map((item, index) => {
        return (
          <div key={`${item.id}-${index}`} className="flex items-center p-3 bg-muted rounded-lg shadow transition cursor-pointer" onClick={() => _handleClick(item.action_urls)}>
            <div className="flex-1">{item.title}</div>
            <ArrowRight />
          </div>
        )
      })}
    </div>
  );
}